import { SessionContextService } from './../../../context/session-context.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Message } from '../../../../../../shared-components/src/lib/models/message.model';
import { SessionService } from '../../../services/session.service';
import { SpinnerService } from 'shared-components';
import { Observable, Subscription, timer } from 'rxjs';


@Component({
  selector: 'app-confirm-registration',
  templateUrl: './confirm-registration.component.html'
})
export class ConfirmRegistrationComponent implements OnInit {

  public confirmRegistrationForm: UntypedFormGroup;
  public showError = false;
  public mensajes = new Array<Message>();
  public showOPassword: boolean;
  public showNPassword: boolean;
  public showRNPassword: boolean;

  private timer: Observable<any>;
  private subscription: Subscription;

  @Input() email: string;
  @Input() guid: string;
  @Input() recovery?: boolean;
  @Output() closeModal = new EventEmitter<boolean>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _sessionService: SessionService,
    private readonly _sessionContext: SessionContextService,
    private readonly _spinnerService: SpinnerService,
    public router: Router,
  ) { }

  ngOnInit() {
    this.confirmRegistrationForm = this._fb.group({
      nombre: ['', Validators.required],
      apellido: ['', Validators.required],
      telefono: ['', Validators.pattern('^[+]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]{5,30}$')],
      cargo: ['', Validators.required],
      password: ['', Validators.required],
      repeatPassword: ['', Validators.required],
      terminos: ['']
    });
  }

  public confirmRegistration() {
    this.mensajes = [];
    this.showError = this.confirmRegistrationForm.invalid;
    if (this.confirmRegistrationForm.valid) {
      if (this.confirmRegistrationForm.get('password').value === this.confirmRegistrationForm.get('repeatPassword').value) {
        this.mensajes = [];
        let registration = {
          id: this.guid,
          nombre: this.confirmRegistrationForm.get('nombre').value,
          apellido: this.confirmRegistrationForm.get('apellido').value,
          telefono: this.confirmRegistrationForm.get('telefono').value ? this.confirmRegistrationForm.get('telefono').value : null,
          password: this.confirmRegistrationForm.get('password').value
        };
        this._spinnerService.showSpinner();
        this._sessionService.confirmRegistration(registration).toPromise().finally(() => {
        this._spinnerService.hideSpinner();
        }).then((resp) => {
          this.showError = true;
          this.mensajes.push({ class: 'success', message: 'usuarios.confirmarRegistro.usuarioInsertado' });

          this.timer = timer(1500);
          this.subscription = this.timer.subscribe(() => {
            this.router.navigate([localStorage.url]);
    });

        },
        (error) => {
          if (error.status === 420) {
            switch (error.error.ApiErrorCode) {
                case 1027:
                  this.pushMessage(error.error.Descripcion);
                  break;
                default:
                  this.showError = true;
                  this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                  break;
            }
          } else {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
          }

        });
      } else {
        this.showError = true;
        this.mensajes.push({ class: 'error', message: 'session.error.noSamePassword' });
      }
    } else {
      this.showError = true;
      this.mensajes.push({ class: 'error', message: 'global.error.required' });
    }
  }

  public pushMessage(mensaje) {
    this.showError = true;
    this.mensajes.push({ class: 'error', message: mensaje });
  }
}
